<template>
  <div>
    <td width="100%">{{ item.data.domain }}</td>
    <td>
      <v-btn
        class="white--text filled-btn"
        tile
        elevation="0"
        color="#58E2C2"
        @click="editDomain(item)"
        >Edit</v-btn
      >
    </td>
    <td>
      <v-btn
        class="white--text filled-btn"
        tile
        elevation="0"
        color="#FF4F4F"
        @click="() => this.$emit('removeDomain',item)"
        >Remove</v-btn
      >
    </td>
  </div>
</template>
<script>
export default {
  name: 'TableRowData',
  props: ['item', 'setSelectedDomain'],
  methods: {
    editDomain(item) {
      this.setSelectedDomain(item);
      this.$router.push({
        path: `edit-domain/${item.id}`,
      });
    },
  },
};
</script>